<template>
    <div>
        <h4>tipo de serviço</h4>
        <div>
            <div class="delivery-option">
                <div class="radio-container-tab">
                    <input
                        type="radio"
                        name="flexRadioDefault"
                        id="flexRadioDefaultMobile1"
                        :checked="selected == delivery"
                        @change="switchServiceType(delivery)"
                    >
                    <label class="container" :class="{ checked: selected == delivery }" for="flexRadioDefaultMobile1">
                        <p>ENTREGA</p>
                    </label>
                </div>
                <div class="radio-container-tab">
                    <input
                        type="radio"
                        name="flexRadioDefault"
                        id="flexRadioDefaultMobile2"
                        :checked="selected == takeaway"
                        @change="switchServiceType(takeaway)"
                    >
                    <label class="container" :class="{ checked: selected == takeaway }" for="flexRadioDefaultMobile2">
                        <p>LEVANTAR NA LOJA</p>
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>


<script>

export default {
    props: {
        defaultSelected: {type: Number, required: true},
        delivery: {type: Number, required: true},
        takeaway: {type: Number, required: true}
    },
    methods: {
        switchServiceType(type){
            console.log(type, 'dee');
            Livewire.emit('onToggleDeliveryMobile', type);
        },
        updateSelected(value) {
            this.selected = value
        },
    },
    data: () => ({
        selected: null
    }),
    mounted() {
        this.updateSelected(this.defaultSelected)
    },
    created() {
        Livewire.on('toggleMobileSelectors', (value) => this.updateSelected(value));
    }
}
</script>
